import { DEFAULT_QUOTE_CLASS_NAME, QUOTE_STATUS_CLASS_NAME } from '../constants';

export default function getQuoteStatusClassName(status) {
  return QUOTE_STATUS_CLASS_NAME[status] || DEFAULT_QUOTE_CLASS_NAME;
}
